__turbopack_context__.v({
  "body": "WhiteSpeechBubble-module__WtAo2G__body",
  "content": "WhiteSpeechBubble-module__WtAo2G__content",
  "empty": "WhiteSpeechBubble-module__WtAo2G__empty",
  "root": "WhiteSpeechBubble-module__WtAo2G__root",
  "tail": "WhiteSpeechBubble-module__WtAo2G__tail",
  "tailLeftBottom": "WhiteSpeechBubble-module__WtAo2G__tailLeftBottom",
  "tailLeftCorner": "WhiteSpeechBubble-module__WtAo2G__tailLeftCorner",
});
